import { useState } from 'react';
import {
  GridColDef, GridRenderCellParams, GridRowsProp, GridValueGetterParams,
} from '@mui/x-data-grid';
import {
  Box, Button, CircularProgress, Typography,
} from '@mui/material';
import { ISeller } from '../interfaces';
import CardTableWrapper from '../../shared/custom/dataGrid/CardTableWrapper';
import CustomDataGrid from '../../shared/custom/dataGrid/CustomDataGrid';
import StudentsStatus from '../../shared/custom/status/StudentsStatus';
import InfoDialog from '../../shared/custom/dialog/InfoDialog';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { addSellerForActions, setSellersDeleteModalState, setSellersModalState } from '../slice/sellersSlice';
import TableMenu from '../../shared/custom/tableMenu.tsx/TableMenu';
import { deleteSeller } from '../actions/sellersActions';

interface ISellersTableProps {
  sellers: ISeller[];
}

const SellersTable = ({ sellers }: ISellersTableProps ) => {
  const dispatch = useAppDispatch();
  const { loadingDelete, modalDelete, seller } = useAppSelector(( state ) => state.seller );

  const handleOpenEditModal = ( id: string ) => {
    dispatch( addSellerForActions( id ));
    dispatch( setSellersModalState( true ));
  };

  const handleOpenDeleteModal = ( id: string ) => {
    dispatch( addSellerForActions( id ));
    dispatch( setSellersDeleteModalState( true ));
  };

  const acceptDelete = ( ) => {
    dispatch( deleteSeller( seller?.id || '' ));
  };

  const [perPage, setPerPage] = useState( 25 );
  const rows: GridRowsProp = sellers.map(
    ( b: ISeller ) => ({
      id: b.id,
      name: b.name,
      lastname: b.lastname,
      email: b.email,
      created: b.created,
      active: b.active,
    }),
  );

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'NOMBRES',
      headerClassName: 'theme__header',
      flex: 1,
    },
    {
      field: 'lastname',
      headerName: 'APELLIDOS',
      headerClassName: 'theme__header',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'EMAIL',
      headerClassName: 'theme__header',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'created',
      headerName: 'CREADO',
      headerClassName: 'theme__header',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: ( params: GridRenderCellParams<number> ) => {
        const date = params.value;
        return (
          <Typography variant="caption">
            {new Date( date ).toLocaleDateString( 'es-ES' )}
          </Typography>
        );
      },
    },
    {
      field: 'active',
      headerName: 'ESTADO',
      headerClassName: 'theme__header',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: ( params: GridRenderCellParams<number> ) => {
        const status = params.value;
        return ( <StudentsStatus status={status} /> );
      },
    },
    {
      field: 'actions',
      headerName: 'ACCIONES',
      width: 200,
      headerClassName: 'theme__header',
      align: 'center',
      headerAlign: 'center',
      renderCell: ( params: GridValueGetterParams ) => {
        const idSellers = params.id as string;
        return (
          <TableMenu
            id={idSellers}
            handleOpenEdit={handleOpenEditModal}
            handleOpenDelete={handleOpenDeleteModal}
          />
        );
      },
    },
  ];

  return (
    <>
      <CardTableWrapper>
        <CustomDataGrid
          noDataMessage="Sin Estudiantes"
          rows={rows}
          columns={columns}
          pageSize={perPage}
          onPageSizeChange={setPerPage}
          rowsPerPageOptions={[25, 50, 75, 100]}
        />
      </CardTableWrapper>
      <InfoDialog
        open={modalDelete}
        title="Eliminar Vendedor"
        contentText="Estás seguro que deseas eliminar a este Vendedor, esta acción es irreversible."
        closeFunction={() => dispatch( setSellersDeleteModalState( !!loadingDelete ))}
      >
        <Box textAlign="center" pt={3}>
          <Button onClick={() => acceptDelete()} disabled={loadingDelete} endIcon={loadingDelete && ( <CircularProgress size={10} /> )}>
            ¡Sí, Eliminar!
          </Button>
        </Box>
      </InfoDialog>
    </>
  );
};

export default SellersTable;
